import React, { memo, useCallback } from 'react';
import { IconWrapper } from './styled';

const IconAddress = memo(({ link, children }) => {
  const openLink = useCallback(
    () => () => {
      window.open(link, '_blank');
    },
    [link]
  );

  return <IconWrapper onClick={openLink(link)}>{children}</IconWrapper>;
});

export default IconAddress;
